import { render, staticRenderFns } from "./TheStatistiquesPage.vue?vue&type=template&id=39ce173c&"
import script from "./TheStatistiquesPage.vue?vue&type=script&lang=js&"
export * from "./TheStatistiquesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheStatistiquesPage.vue"
export default component.exports